module.exports = __webpack_public_path__ + "img/win_sml.17c68033.jpg";